import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../routing/LangRouter";
import { numberToText } from "../utils/numberToText";

const useNumberToTextInput = initialValue => {
    const { locale } = useContext(LocaleContext);

    const [rawValue, setRawValue] = useState(null);
    const [displayValue, setDisplayValue] = useState(""); // Comma-separated formatted value
    const [numberText, setNumberText] = useState("");

    const getLanguageFromLocale = locale => {
        const languageMap = {
            fa: "persian",

            en: "english",

            ar: "arabic",
        };

        return languageMap[locale] || "persian";
    };

    const currentLanguage = getLanguageFromLocale(locale);

    const formatNumber = num => {
        return new Intl.NumberFormat("en-US").format(num);
    };

    //handle default value
    useEffect(() => {
        if (initialValue) {
            setDisplayValue(initialValue);
            setRawValue(initialValue);
            setNumberText(numberToText(parseInt(initialValue), currentLanguage));
        }
    }, [initialValue, currentLanguage]);

    const handleAmountChange = event => {
        const inputElement = event.target;
        const rawValue = inputElement.value.replace(/,/g, ""); // Remove commas from the input

        // Allow only numeric input
        if (rawValue === "" || /^\d+$/.test(rawValue)) {
            const formattedValue = formatNumber(rawValue); // Format with commas
            setDisplayValue(formattedValue);

            // Convert raw number to Persian text
            if (rawValue) {
                setNumberText(numberToText(parseInt(rawValue), currentLanguage));
                setRawValue(rawValue);
            } else {
                setNumberText(""); // Clear Persian text if input is empty
            }
        }
    };

    return { rawValue, displayValue, numberText, handleAmountChange };
};

export default useNumberToTextInput;
